import './App.css';
import { Routes, Route, useLocation } from "react-router-dom";
import HomePage from './pages/HomePage';
import Gallery from './pages/GalleryPage';
import AboutPage from './pages/AboutPage';
import NotFound from './pages/NotFound';

import BoatPage from "./pages/BoatPage"
import BoatDetailPage from "./pages/BoatDetailPage";
import StandardProductDetailPage from "./pages/StandardProductDetailPage";
import ContactPage from './pages/ContactPage';
import EnginesPage from "./pages/EnginesPage";
import AllNewsPage from './pages/AllNewsPage';
import Navbar from './components/Navbar';
import TopInfoBar from './components/TopInfoBar';
import Footer from './components/Footer';
import NewsDetailPage from './pages/NewsDetailPage';

import AccessoriesPage from './pages/AccessoriesPage';
import AccessoryDetail from './pages/AccessoryDetail';
import UsedProducts from './pages/UsedProducts';
import SpotLockPage from './pages/SpotLockPage';
import VideoGalleryPage from './pages/VideoGalleryPage';
import { Toaster } from 'sonner';

// Admin Panel Imports
import AdminLayout from './layouts/AdminLayout';
import LoginPage from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import NewsList from './pages/admin/News/NewsList';
import AddNews from './pages/admin/News/AddNews';
import VideoList from './pages/admin/Videos/VideoList';
import AddVideo from './pages/admin/Videos/AddVideo';
import GalleryList from './pages/admin/Gallery/GalleryList';
import AddImage from './pages/admin/Gallery/AddImage';
import BoatList from './pages/admin/Boats/BoatList';
import AddBoat from './pages/admin/Boats/AddBoat';
import EditBoat from './pages/admin/Boats/EditBoat';
import UsedBoatList from './pages/admin/UsedBoats/UsedBoatList';
import AddUsedBoat from './pages/admin/UsedBoats/AddUsedBoat';
import EditUsedBoat from './pages/admin/UsedBoats/EditUsedBoat';
import EngineList from './pages/admin/Engines/EngineList';
import AddEngine from './pages/admin/Engines/AddEngine';
import ProductList from './pages/admin/Products/ProductList';
import AddProduct from './pages/admin/Products/AddProduct';


function App() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const isContactPage = location.pathname === "/iletisim";
  const isAdminPage = location.pathname.startsWith("/panel");

  return (
    <div className={`min-h-screen text-white flex flex-col ${isAdminPage ? 'bg-gray-100' : ''}`}>
      <Toaster position='top-right' closeButton></Toaster>
      {!isAdminPage && (
        <>
          {isHomePage && <TopInfoBar />}
          <Navbar />
          {!isHomePage && !isContactPage && <TopInfoBar />}
        </>
      )}


      <main className="flex-grow ">
        <Routes>
          <Route path="/videolar" element={<VideoGalleryPage />} />
          <Route path="/urunler/ikinciel" element={<UsedProducts />} />
          <Route path="/urunler/sanalcapa" element={<SpotLockPage />} />
          <Route path="/kategori/:slug" element={<AccessoryDetail />} />
          <Route path="/urunler/tekne-ve-yatlar" element={<BoatPage />} />
          <Route path="/urunler/motorlar" element={<EnginesPage/>} />
          <Route path="/urunler/aksesuarlar" element={<AccessoriesPage />} />

          <Route path="/" element={<HomePage/>} />
          <Route path="/ayvalik-marin" element={<AboutPage/>} />
          <Route path="/iletisim" element={<ContactPage/>} />
          <Route path="/haberler" element={<AllNewsPage/>} />
          <Route path="/home" element={<HomePage/>} />
          <Route path="/galeri" element={<Gallery/>} />
          <Route path="/haber/:newsId" element={<NewsDetailPage />} />
          <Route path="/ikinciel/:slug" element={<BoatDetailPage type="used"/>} />
          
          <Route path="/urunler/motor/:slug" element={<StandardProductDetailPage type="engine"/>} />
      <Route path="/urunler/aksesuar/:slug" element={<StandardProductDetailPage type="product"/>} />
      <Route path="/urunler/:slug" element={<BoatDetailPage type="boat"/>} />
      
      {/* Admin Panel Routes */}
          <Route path="/panel/login" element={<LoginPage />} />
          <Route path="/panel" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="news" element={<NewsList />} />
            <Route path="news/add" element={<AddNews />} />
            <Route path="videos" element={<VideoList />} />
            <Route path="videos/add" element={<AddVideo />} />
            <Route path="gallery" element={<GalleryList />} />
            <Route path="gallery/add" element={<AddImage />} />
            <Route path="boats" element={<BoatList />} />
            <Route path="boats/add" element={<AddBoat />} />
            <Route path="boats/edit/:id" element={<EditBoat />} />
            <Route path="used-boats" element={<UsedBoatList />} />
            <Route path="used-boats/add" element={<AddUsedBoat />} />
            <Route path="used-boats/edit/:id" element={<EditUsedBoat />} />
            <Route path="engines" element={<EngineList />} />
            <Route path="engines/add" element={<AddEngine />} />
            <Route path="engines/edit/:id" element={<AddEngine />} />
            <Route path="products" element={<ProductList />} />
            <Route path="products/add" element={<AddProduct />} />
          </Route>

          { <Route path="*" element={<NotFound />} />}
        </Routes>
      </main>
      {!isAdminPage && <Footer></Footer>}
    </div>

  );
}

export default App;
